const createCountryStore = (set) => ({
  countriesList: undefined,
  isLoading: false,

  setCountries: (countries) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        countries: {
          ...state.superadmin.countries,
          countriesList: countries,
        },
      },
    })),

  setLoading: (isLoading) =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        countries: {
          ...state.superadmin.countries,
          isLoading,
        },
      },
    })),

  // Reset store to initial state
  reset: () =>
    set((state) => ({
      superadmin: {
        ...state.superadmin,
        countries: {
          countriesList: [],
          isLoading: false,
        },
      },
    })),
});

export default createCountryStore;
